// extracted by mini-css-extract-plugin
module.exports = {"tick-list":"tick-list_tick-list__LpgG7","tick-list--squeezed":"tick-list_tick-list--squeezed__szx94","tick-list__icon":"tick-list_tick-list__icon__vKiDe"};